export enum SiglaTemplateDTO {
    UserCourseProgressionUpdated = "UserCourseProgressionUpdated",
    COMPLETION_CERTIFICATE = "COMPLETION_CERTIFICATE",
    Achievement = "Achievement",
    ExamWaitingSentAutoMarking = "ExamWaitingSentAutoMarking",
    EXAM_CORRECTED = "EXAM_CORRECTED",
    EXAM_WAITING_MARK = "EXAM_WAITING_MARK",
    AdminNotifications = "AdminNotifications",
    ExamsReportCompleted = "ExamsReportCompleted",
    UserSaved = "USER_SAVED",
    ConfirmacaoDeInscricaoEmCurso = "CONFIRMACAO_DE_INSCRICAO_EM_CURSO",
    ConfirmacaoDeInscricaoEmPacote = "CONFIRMACAO_DE_INSCRICAO_EM_PACOTE",
    ConfirmacaoDeInscricaoEmTrilha = "CONFIRMACAO_DE_INSCRICAO_EM_TRILHA"
}
